import { env0Themes, type Env0Theme as GeneratedEnv0Theme } from '@env0/ui-theme/env0';
import { showNewDesign } from 'constants/config';
import { legacyThemes } from './themes.constants.legacy';

export const TOP_BAR_HEIGHT = '50px';
export const NAVBAR_WIDTH = '220px';
export const NAVBAR_COLLAPSED_WIDTH = '50px';
export const NAVBAR_TRANSITION_DURATION = '300ms';
export const BREADCRUMB_BAR_HEIGHT = '35px';

/**
 * The generated bridge is rebuilt from Figma, so the switch is added here instead. Styled components
 * branch on it — `({ theme }) => theme.isNewDesign` — and APO-484 deletes both the key and the
 * branches after the flip.
 */
export type Env0Theme = GeneratedEnv0Theme & { isNewDesign: boolean };

export const newDesignThemes = {
  light: { ...env0Themes.light, isNewDesign: true },
  dark: { ...env0Themes.dark, isNewDesign: true }
} satisfies Record<'light' | 'dark', Env0Theme>;

// Some generated tokens still carry wrong values, so the legacy themes stay the default.
export const selectThemes = (isNewDesign: boolean) => (isNewDesign ? newDesignThemes : legacyThemes);

const themes = selectThemes(showNewDesign());

export const darkTheme = themes.dark;

declare module '@emotion/react' {
  export interface Theme extends Env0Theme {}
}

export default themes.light;
